import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Version } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CanActivate } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { APP_ENVIRONMENT, APP_VERSION } from '@qtek/core/api-core';
import { MetaActions, selectGuiDomain } from '@qtek/libs/store';
import { Environment } from '@qtek/shared/models';
import { Observable, of } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

@Injectable()
export class IconReadyGuard implements CanActivate {
  private registered = false;

  constructor(
    private store: Store,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    @Inject(APP_ENVIRONMENT) private environment: Environment,
    @Inject(APP_VERSION) private version: Version,
    @Inject(DOCUMENT) private document: Document
  ) {}

  canActivate(): Observable<boolean> {
    this.store.dispatch(MetaActions.loadMetaGuiDomain());

    if (this.registered) {
      return of(true);
    }
    return this.store.pipe(
      select(selectGuiDomain),
      filter(Boolean),
      take(1),
      map(domain => {
        this.registerIcons(domain);
        this.registered = true;
        return true;
      })
    );
  }

  private registerIcons(domain: string): void {
    let iconsPath: string;

    if (this.environment.production) {
      iconsPath = `${domain}/assets/img/icons/icons.svg?v=${this.version.full}`;
    } else {
      const { host } = this.document.location;
      iconsPath = `//${host}/assets/img/icons/icons.svg?v=${this.version.full}`;
    }

    const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iconsPath);

    this.iconRegistry.addSvgIconSet(safeUrl);
  }
}
